// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"389468da","389":"4202cf06","453":"aaea29a3","732":"5898f033","977":"0e2c204e"}[chunkId] + ".chunk.js";
};